/** How extra layout clip slots (Cortes photos, Fofoca story) should play.

The editor Player cannot afford extra @remotion/media decoders of the same
library source — each copy plus getVideoMetadata starves the preview after a
second or two. Export still needs a live muted copy so empty slots match the
main clip. */
export type LayoutClipCopyHost = 'preview' | 'export';
export type LayoutClipCopyMode = 'live' | 'still';

export function resolveLayoutClipCopyMode(host: LayoutClipCopyHost): LayoutClipCopyMode {
  return host === 'export' ? 'live' : 'still';
}
